import { CircleCheck } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import { useCart } from '@/hooks/useCart';
import { useShop } from '@/hooks/useShop';

/** "נוסף לסל" for 3 s after every add, with a link to the cart */
export function CartToast() {
  const { lastAdded } = useCart();
  const { byId } = useShop();
  const [shown, setShown] = useState<number>();
  useEffect(() => {
    if (!lastAdded) return;
    setShown(lastAdded.productId);
    const t = setTimeout(() => setShown(undefined), 3000);
    return () => clearTimeout(t);
  }, [lastAdded]);
  const p = shown != null ? byId.get(shown) : undefined;
  if (!p) return null;
  return (
    <div className="animate-in fade-in slide-in-from-bottom-4 fixed inset-x-3 bottom-[calc(1rem+var(--tg-bottom))] z-[60] mx-auto flex max-w-md items-center gap-3 rounded-2xl border border-white/10 bg-neutral-900 p-3 shadow-2xl">
      <CircleCheck className="size-6 shrink-0 text-emerald-400" />
      <span className="min-w-0 flex-1 truncate text-sm">
        נוסף לסל: <b>{p.name}</b>
      </span>
      <Link to="/cart" className="brand-grad shrink-0 rounded-full px-4 py-1.5 text-sm font-bold text-white">
        לסל
      </Link>
    </div>
  );
}
